<div class="modal-header p-1 justify-content-end">
    <a style="text-decoration: none; padding: 24px" tabindex="0" (click)=" bsModalRef.hide()">
        <span aria-hidden="true" class="icon-ui-close"></span>
    </a>
</div>
<div class="modal-body gb-align-center pt-0 px-16 pb-10">
    <div *ngIf="expiredPlans.length > 1" class="gb-headline2 pb-6">
        {{multiplePlanExpiryMessage}}
    </div>
    <div *ngIf="expiredPlans.length === 1" class="gb-headline2 pb-6">
        {{singlePlanExpiryMessage}}
    </div>
    <div *ngIf="expiredPlans.length === 1" class="col-md-8 mx-auto pb-6">
        <button 
            tabindex="0"
            class="gb-primary-button"
            [attr.aria-label]="buttonText"
            [trackLink]="buttonText"
            trackType="o"
            [prop15]="buttonText"
            [prop10]="trackingString('button', ['expired',buttonText])"
            [evar33]="trackingString('button', ['expired',buttonText])"
            (click)="goToRenew()">
            {{buttonText}}
        </button>
    </div>
    <div tabindex="0" class="gb-body2">
        <a 
            tabindex="0"
            class="gb-link py-0"
            [attr.aria-label]="shopAllPlansLink"
            [trackLink]="shopAllPlansLink"
            trackType="o"
            [prop15]="shopAllPlansLink"
            [prop10]="trackingString('link', ['expired',shopAllPlansLink])"
            [evar33]="trackingString('link', ['expired',shopAllPlansLink])" 
            (click)="goToDlp()">
            {{shopAllPlansLink}}
        </a>
    </div>
</div>
